<!--  -->
<template>
  <div>
    <el-form
      :model="formInline"
      class="demo-form-inline"
    >
      <el-form-item v-if="mode==='pull'" label="日期">
        <div class="block">
          <el-date-picker
            v-model="date"
            type="daterange"
            align="right"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </div>
      </el-form-item>
      <el-form-item label="广告id">
        <el-button
          type="success"
          size="mini"
          @click="bandwechat"
        >选择</el-button>
        <div style="width: 580px; height: 200px; overflow: auto;">
          <el-tag
            v-for="(itemr,index) in arrs"
            :key="index"
            style="margin-right:10px;margin-bottom:5px"
            closable
            :type="itemr.type"
            @close="rightclick(index)"
          >
            {{ itemr.advertiser_name }}
          </el-tag>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="arrs=[]"
        >一键清空</el-button>
        <el-button
          type="primary"
          @click="onSubmit"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择广告主"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <choosepeol
        ref="choosepeolview"
        @bandarr="bandarr"
      />
    </el-dialog>
  </div>
</template>

<script>
import choosepeol from './choosepeol.vue'
export default {
  components: { choosepeol },
  props: {
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formInline: {
        account_ids: [],
        start_time: null,
        end_time: null
      },
      rules: {
        name: [{ required: true, message: '请选择id', trigger: 'blur' }]
      },
      date: [this.getNowFormatDate(window.Date.now()), this.getNowFormatDate(window.Date.now())],
      dialogVisibler: false,
      arrs: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    onSubmit() {
      if (this.mode === 'pull') {
        if (this.date === null) return this.$message('必须选择日期哦~')
        this.formInline.start_time = this.date && this.date.length ? this.date[0] : null
        this.formInline.end_time = this.date && this.date.length ? this.date[1] : null
      } else {
        this.formInline = {
          account_ids: this.formInline.account_ids
        }
      }
      console.log('submit!', this.date, this.formInline)
      if (this.formInline.account_ids.length === 0) return this.$message('请选择广告id~')
      this.$emit('addPull', this.formInline)
      this.arrs = []
    },
    sendr() {},
    async bandarr(arr) {
      console.log('66666', arr)
      this.dialogVisibler = false
      this.arrs = arr
      this.formInline.account_ids = []
      arr.forEach(element => {
        this.formInline.account_ids.push(element.account_id)
      })
    },
    bandwechat() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.choosepeolview.sendr(this.arrs)
      })
    },
    rightclick2(index) {
      this.merchant_ids.splice(index, 1)
    },
    rightclick(index) {
      this.arrs.splice(index, 1)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
